angular.module('mercury.modules.time.payroll.paytypes.special')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Time.Payroll.SpecialList', {
    url: '/paytypes/special',
    controller: 'TimePayrollSpecialListCtrl',
    templateUrl: 'modules/time/payroll/paytypes/special/list.tpl.html'
  });
}]);
